import { IconContent } from '@icons';

export const chevronRight: IconContent = {
    sm: '<path d="m10.78 7.823-4.853 4.854-.707-.707 4.146-4.147L5.22 3.677l.707-.707 4.853 4.853Z" />',
};
